import React from 'react'
import Footer from '../../Layout/Footer'
import Header from '../../Layout/Header'
import FAQ from './FAQ'
import SeoTagsFooter from './SeoTagsFooter'

function TermsConditions() {
  return (
    <div className="page_wrapper">
      <Header/>
      <main className="page_content">

        {/* Page Header */}
        <section 
          className="page_header text-center bg-dark section_decoration overflow-hidden" 
          style={{backgroundImage :"url('assets/images/backgrounds/page_header_bg_1.webp')"}}
        >
          <div className="container">
            <h1 className="page_title text-white">Terms &amp; Conditions</h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li><a href="/">Home</a></li>
              <li className="active"><a href="#!">Terms &amp; Conditions</a></li>
            </ul>
          </div>
          <div className="decoration_item shape_nate">
            <img src="assets/images/shapes/shape_nate.svg" alt="Shape Nate"/>
          </div>
        </section>

        {/* Terms & Conditions Content */}
        <section className="feature_section section_space">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="heading_block mb-4 text-center">
                 
                  <p className="heading_description mb-0" style={{textAlign:'left'}}>
                    Please read these Terms &amp; Conditions (“Terms”) carefully before using Mokshiq services (operated by <strong>Rakle Service Private Limited</strong>). 
                    By accessing or using our platform, you agree to be bound by these Terms.
                  </p>
                </div>

                <div className="policy_content">
                  <h4>1. Acceptance of Terms</h4>
                  <p>
                    By registering, accessing, or using Mokshiq’s services, you agree to comply with these Terms. 
                    If you do not agree, you must stop using the platform immediately.
                  </p>

                  <h4>2. Eligibility</h4>
                  <p>
                    You must be at least 18 years old, possess a valid Indian PAN / Aadhaar, and be legally capable of entering into a binding agreement.
                  </p>

                  <h4>3. User &amp; Partner Obligations</h4>
                  <ul>
                    <li>Provide accurate and complete KYC information during onboarding.</li>
                    <li>Maintain strict confidentiality of your login credentials and 2FA biometric keys.</li>
                    <li>Ensure AEPS, DMT, and Recharge transactions comply with NPCI, RBI, and telecom guidelines.</li>
                  </ul>

                  <h4>4. Services &amp; APIs</h4>
                  <p>
                    Mokshiq provides digital financial solutions including AEPS, DMT, mATM, Verify verification APIs, recharges, and utility bill payments. 
                    Rakle Service Private Limited reserves the right to modify or update API rate limits and service parameters as required by banking nodes.
                  </p>

                  <h4>5. Governing Law &amp; Jurisdiction</h4>
                  <p>
                    These Terms are governed by and construed in accordance with the laws of India. 
                    Any legal disputes shall be subject to the exclusive jurisdiction of the courts in Noida, Uttar Pradesh.
                  </p>

                  <h4>6. Contact Us</h4>
                  <p>
                    For legal or compliance inquiries regarding these Terms, contact us at: <br/>
                    Email: <a href="mailto:support@mokshiq.in">support@mokshiq.in</a> | Phone: <a href="tel:+917311104571">+91 7311104571</a><br/>
                    Address: 1st Floor, C 78, Sector-2 Noida, Uttar Pradesh
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ 
          title="Terms & Compliance FAQs"
          subtitle="Frequently asked questions about retailer agreements, terms, and regulatory standards."
        />

      </main>
      <Footer/>
      <SeoTagsFooter/>
    </div>
  )
}

export default TermsConditions
